import { render, staticRenderFns } from "./HomeHeader2.vue?vue&type=template&id=2b5489da&scoped=true"
import script from "./HomeHeader2.vue?vue&type=script&lang=js"
export * from "./HomeHeader2.vue?vue&type=script&lang=js"
import style0 from "./HomeHeader2.vue?vue&type=style&index=0&id=2b5489da&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5489da",
  null
  
)

export default component.exports